import { cn } from "@/lib/utils";

export type TrafficStatus = "green" | "amber" | "red" | "neutral";

interface TrafficBadgeProps {
  status: TrafficStatus;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const TrafficBadge = ({ status, size = "md", className }: TrafficBadgeProps) => {
  const sizeClasses = {
    sm: "h-2 w-2",
    md: "h-3 w-3",
    lg: "h-4 w-4",
  };

  const statusClasses = {
    green: "bg-success",
    amber: "bg-warning",
    red: "bg-danger",
    neutral: "bg-muted-foreground",
  };

  return (
    <div
      className={cn(
        "rounded-full transition-smooth",
        sizeClasses[size],
        statusClasses[status],
        className
      )}
      aria-label={`Status: ${status}`}
    />
  );
};
